import { MutationTree } from "vuex";
import { StatePaymentSystems } from "@/store/types";
import { MUTATION_TYPES } from "@/lib/const";

const { STORE_DATA } = MUTATION_TYPES;

export const mutations: MutationTree<StatePaymentSystems> = {
  [STORE_DATA]: (state, payload) => {
    state.systems = payload;
  },
};
